const form = document.querySelector("form.crawfish-form");

if (form) {
  form.addEventListener("submit", function(event) {
    event.preventDefault();

    const formData = new FormData(form);
    const thankYouPage = form.querySelector("#thank-you-page").getAttribute("href");
    const button = form.querySelector("button[type='submit']");
    button.disabled = true;

    fetch(form.action, {
      method: "POST",
      body: formData,
    })
    .then(response => {
      //window.location.href = "/thank-you";
    })
    .catch((error) => {
      //window.location.href = "/thank-you";
    })
    .finally(() => {
      form.setAttribute("action", thankYouPage);
      form.submit();
    });
  });

  const radioInputs = form.querySelectorAll("input[name='entry.1559398068']");
  radioInputs.forEach(radioInput => {
    radioInput.addEventListener("change", function(event) {
      const value = event.target.value;
      const selects = form.querySelectorAll("#seats select");
      if (value === "Attending") {
        form.querySelector("#seats").classList.remove("hidden");
        selects.forEach(select => {
          select.setAttribute("required", "");
        });
      } else {
        form.querySelector("#seats").classList.add("hidden");
        selects.forEach(select => {
          select.value = "";
          select.removeAttribute("required");
        });
      }
    });
  });

}